import React, { useEffect, useState } from "react";
import { TutorLayout } from "../../../layout/tutorLayout";
import { useNavigate } from "react-router-dom";
import { useGetFollowersQuery, useGetViewersQuery, useLazyGetBookingsQuery } from "../../../service/tutorApi";
import { showError } from "../../../constants/toast";
import moment from "moment";
import Pagination from "../../../constants/Pagination";
import Loader from "../../../constants/Loader";
import NewSideBarTutor from "../../../components/NewSideBarTutor";
import { Class_Variables } from "../../../constants/enums";

export default function TutorFollowers() {
  const navigate = useNavigate();
  
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);
  const [tab,setTab]=useState<number>(1);
  const [user,setUser]=useState<any[]>([]);
  
  const {data:followers,isLoading:loadingFollowers,isSuccess}=useGetFollowersQuery({page:page,limit:20})
  const {data:viewers,isLoading:loadingViewers,isSuccess:isSuccessView}=useGetViewersQuery({page:page,limit:20})



  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  let totalPages = Math.ceil(count / 20);


  useEffect(()=>{
    if(tab==1 && isSuccess){
        setUser(followers?.data?.followers||[])
        setCount(followers?.data?.totalFollowers||0)
    }else if(tab==2 && isSuccessView ){
        setUser(viewers?.data?.viewers||[])
        setCount(viewers?.data?.totalViewers||0)
    }
  },[tab,isSuccess,page])
 
  return (
    <>
      <TutorLayout className="role-layout">
        <Loader isLoad={loadingFollowers||loadingViewers} />
        <main className="content">
          
          <section className="uhb_spc pBookingDetail_sc home_wrp">
            <div className="conta_iner v2">
              <div className="gap_m grid_2">
                <NewSideBarTutor />
                <div className=" pdf_inr  rt_v2">
                    <div className="tab_div">
                        <p onClick={()=>setTab(1)} className={tab==1? "active":""}>Followers</p>
                        <p onClick={()=>setTab(2)} className={tab==2 ?"active":""}>Viewers</p>
                    </div>
                  <div
                    style={{ paddingTop: "40px" }}
                    className="users_list gap_m"
                  >
                    {user?.length ? (
                      user?.map((item: any, index: number) => {
                        return (
                          <div
                            className="user_item"
                           
                          >
                           
                            <div className="infoBox">
                              <figure>
                                <img
                                  src={
                                    item?.parentId?.image
                                      ? item?.parentId?.image
                                      : `/static/images/user.png`
                                  }
                                  alt="Image"
                                />
                              </figure>
                              <h2>
                                {item?.parentId?.name ? item?.parentId.name : "-"}
                              </h2>
                              <ul>
                                <li>
                                  <span> {item?.parentId?.email
                                      ? item?.parentId?.email
                                      : "-"}</span>
                                
                                </li>
                                <li>
                                  <span>{item?.parentId?.phoneNo
                                      ? item?.parentId?.dialCode+" "+ item?.parentId?.phoneNo
                                      : "-"}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="no_data">
                        <figure>
                          <img
                            src="/static/images/noData.png"
                            alt="no data found"
                          />
                        </figure>
                        <p>No user found</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {user?.length ? (
                <Pagination
                  module={user}
                  page={page}   
                  onPageChange={onPageChange}
                  totalPages={totalPages}
                />
              ) : (
                ""
              )}
            </div>
          </section>
        </main>
      </TutorLayout>
    </>
  );
}
